import gql from 'graphql-tag';
import { ADDRESS_FRAGMENT } from './address';

export const CUSTOMER_FRAGMENT = gql`
  fragment Customer on Customer {
    id
    createdAt
    updatedAt
    title
    lastName
    phoneNumber
    emailAddress
    availablePoints
    addresses {
      ...Address
    }
    user {
      id
      createdAt
      updatedAt
      identifier
      verified
      lastLogin
      customFields
    }
    distributor {
      id
      name
      phone
    }
    customFields {
      distributor {
        id
        name
        phone
      }
      headPortrait
      gender
      dateBirth
      wechatCode
      isModified
      points
    }
  }
  ${ADDRESS_FRAGMENT}
`;
